import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

const SESSION_PERSISTENCE_KEY = "flashysites_remember_me";

/**
 * Hook that manages session persistence based on "Remember me" preference.
 * When "Remember me" was not checked during login, the session will be
 * cleared when the browser/tab is closed.
 */
export const useSessionPersistence = () => {
  useEffect(() => {
    const handleBeforeUnload = () => {
      // Check if this is a "don't remember me" session
      const shouldClearSession = sessionStorage.getItem(SESSION_PERSISTENCE_KEY) === "false";
      
      if (shouldClearSession) {
        // Clear the session on browser close
        // Note: This runs synchronously before page unload
        supabase.auth.signOut();
      }
    };

    // Only add listener if we have a "don't remember me" session
    if (sessionStorage.getItem(SESSION_PERSISTENCE_KEY) === "false") {
      window.addEventListener("beforeunload", handleBeforeUnload);
    }

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
};
